import { Avatar } from "../avatar";
import { rgba } from "polished";
import React, { FunctionComponent } from "react";
import styled from "styled-components";
import TracPage from "@services/tracpage/types/trac-page";

interface ArtistInfoDetailProps {
  className?: string;
  pageData: TracPage;
}

const ArtistInfo: FunctionComponent<ArtistInfoDetailProps> = ({
  className,
  pageData,
}) => {
  return (
    <div className={className || ""}>
      <Avatar
        title={pageData?.title}
        src={pageData?.avatar}
        alt={pageData?.title}
        isSmall
      />
      <div className="info">
        <h6>{pageData?.title}</h6>
        <p>Thank you for your support!</p>
      </div>
    </div>
  );
};

export const ArtistInfoDetail = styled(ArtistInfo)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  gap: 16px;
  border-radius: 900px;
  border: 1px solid ${({ theme }) => rgba(theme.colors.primary, 0.1)};
  background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
  width: 100%;
  max-width: 380px;
  backdrop-filter: blur(4px);

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    max-width: 100%;
  }

  .info {
    h6,
    p {
      margin: 0;
    }

    h6 {
      color: ${({ theme }) => theme.colors.primary};
      font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
      font-size: 14px;
      font-weight: 800;
      line-height: 100%; /* 14px */
    }

    p {
      color: ${({ theme }) => theme.colors.textGrey};
      font-size: 14px;
      font-weight: 400;
      line-height: 145%; /* 20.3px */
    }
  }
`;
